import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import ResponsiveSection from "@/components/ResponsiveSection";
import HeaderBar from "@/components/HeaderBar";

export default function WelcomePage() {
  return (
    <div className="public-page min-h-screen flex flex-col">
      <HeaderBar />

      <ResponsiveSection>
        <motion.h1
          className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Telegram 群组自动打卡
        </motion.h1>
        <motion.p
          className="text-base sm:text-lg md:text-xl text-slate-400 mb-8"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          注册账号后，连接 Telegram 并设置打卡内容与群组。
        </motion.p>
        <motion.div
          className="public-home-actions"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.4, duration: 0.4 }}
        >
          <Link
            to="/login"
            className="public-home-login"
          >
            登录
          </Link>
          <Link
            to="/register"
            className="public-home-register"
          >
            注册账号
          </Link>
        </motion.div>
      </ResponsiveSection>

      <footer className="p-4 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} TG Checkin
      </footer>
    </div>
  );
}
